import React from "react";

/* COMPONENTS */
import HomeFeatures from "components/homepage/features";
import HomePricing from "components/homepage/pricing";
import CallToAction from "components/common/cta";
import Banner from "components/homepage/banner";

const Homepage = () => {
  return (
    <section className="p-0">
      {/* BANNER */}
      <Banner />

      {/* FEATURES */}
      <HomeFeatures />

      {/* PRICING PLANS */}
      <HomePricing />

      {/* CALL TO ACTION */}
      <CallToAction />
    </section>
  );
};

export default Homepage;
